/*require('./../../../style/input-plugin/shortcut.less');*/
var $ = require('jQuery');
var template = require('./../../../template/input-plugin/user-contactinfo.html');
var Plugin = require('./Plugin');
var config = require('../../../global/config');
var dispatcher = require('.././../../global/dispatcher');
var ActionType = require('../../../constant/ActionType');

//var stat = require('./../../../global/stat');
//var StatPoint = require('./../../../constant/StatPoint');

var UserContactinfo = function (options) {
    this._opened = false;

    (function (self) {
        var defaults = {
            template: template,
            texts: []
        };
        $.extend(defaults, options);
        Plugin.call(self, defaults);
        var eleTextList = self._element.find('.im-contactinfo-texts');
        //点击用户名片
        self._element.find('.im-contactinfo-icon').click(function () {
            if (self._opened) {
              self.close();
            } else {
              self.open();
            }
            if (eleTextList[0].getElementsByTagName('li') && eleTextList[0].getElementsByTagName('li').length > 0) {
              return;
            } else {
              config['user-contactinfo'].forEach(item => {
                if (self._data.is_anonymous_user !== false && item === '索取TA的联系方式') {
                  return;
                }
                $('<li>').text(item).appendTo(eleTextList);
              }); 
            }
              
        });
        eleTextList.click(function (e) {
          self.close();
          //点击发送我的联系方式
          if (e.target.tagName == 'LI' && e.target.innerText==="发送我的联系方式") {
            dispatcher.dispatch({
              type: ActionType.PROVIDE_CONTACTINFO,
              data: '我的联系方式'
            });
          //点击索取ta的联系方式
          }else if(e.target.tagName == 'LI' && e.target.innerText==="索取TA的联系方式"){
            self._input.askContactinfo();
          }
      });

      $(self._win).click(function (e) {
          if (self._opened && !$.contains(self._element[0], e.target))
              self.close();
      });
    })(this);
};
UserContactinfo.prototype = Object.create(Plugin.prototype);

module.exports = UserContactinfo;
